export default {
  save: '保存',
  cancel: 'キャンセル',
  no_results: '結果なし',
}